import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';

import './otpBoxes.scss';

const OtpBoxes = ({ onChange }) => {
  const [chars, setChars] = useState(Array(6).fill(''));
  const refs = useRef([]);

  const notify = (arr) => onChange(arr.join(''));

  const handleChange = (idx, val) => {
    const digit = val.replace(/\D/g, '').slice(-1);
    const next = [...chars];
    next[idx] = digit;
    setChars(next);
    notify(next);
    if (digit && idx < 5) refs.current[idx + 1]?.focus();
  };

  const handleKeyDown = (idx, e) => {
    if (e.key === 'Backspace') {
      const next = [...chars];
      if (!chars[idx] && idx > 0) {
        next[idx - 1] = '';
        setChars(next);
        notify(next);
        refs.current[idx - 1]?.focus();
      } else if (chars[idx]) {
        next[idx] = '';
        setChars(next);
        notify(next);
      }
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6);
    const next = Array.from({ length: 6 }, (_, i) => pasted[i] || '');
    setChars(next);
    notify(next);
    refs.current[Math.min(pasted.length, 5)]?.focus();
  };

  return (
    <div className="otp-boxes">
      {chars.map((char, i) => (
        <input
          key={`otp-box-${i + 1}`}
          ref={(el) => { refs.current[i] = el; }}
          type="text"
          inputMode="numeric"
          maxLength={1}
          value={char}
          onChange={(e) => handleChange(i, e.target.value)}
          onKeyDown={(e) => handleKeyDown(i, e)}
          onPaste={handlePaste}
        />
      ))}
    </div>
  );
};

OtpBoxes.propTypes = {
  onChange: PropTypes.func.isRequired,
};

export default OtpBoxes;
